import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SideBar } from './components/sidebar';
import { TopBar } from './components/topbar';
import { DrawerService } from './drawer.service';

@Component({
  selector: 'mc-shell',
  template: `
    <div class="flex h-dvh flex-col">
      <header class="sticky top-0 z-10">
        <mc-topbar />
      </header>

      <div class="flex grow items-stretch overflow-hidden">
        <!-- Desktop sidebar -->
        <aside class="hidden md:block">
          <mc-sidebar />
        </aside>

        <main class="grow overflow-y-auto">
          <router-outlet />
        </main>
      </div>
    </div>

    <!-- Mobile drawer backdrop -->
    <div
      class="fixed inset-0 z-20 bg-black/60 transition-opacity duration-300 md:hidden"
      [class.opacity-100]="drawer.isOpen()"
      [class.opacity-0]="!drawer.isOpen()"
      [class.pointer-events-none]="!drawer.isOpen()"
      (click)="drawer.close()"
    ></div>

    <!-- Mobile drawer -->
    <aside
      class="fixed bottom-0 left-0 top-[env(safe-area-inset-top)] z-30 transition-transform duration-300 ease-in-out md:hidden"
      [class.-translate-x-full]="!drawer.isOpen()"
      [class.translate-x-0]="drawer.isOpen()"
    >
      <mc-sidebar />
    </aside>
  `,
  imports: [RouterOutlet, TopBar, SideBar],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Shell {
  protected drawer = inject(DrawerService);
}
